import DeviceAddressService from "../../apis/device-address";
import DeviceDataService from "../../apis/device-data"
import LampDataService from "../../apis/lamps-data";
import PoleDataService from "../../apis/pole-data";
import { lampStatusCode } from "../../constants/constants";
import { GetDailyReportQuery, GetLampReportQuery } from "../../query/report.query"
import format from "date-fns/format";

export function GetDailyReport(startDate, endDate, zone = 0, ward = 0, devId = null) {
    console.log("===== ReportManager : GetDailyReport() ========");
    var reportList = [];
    return new Promise(function (resolve, reject) {
        GetDailyReportQuery(startDate, endDate, zone, ward, devId).then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                console.log("ReportManager : GetDailyReport() users docs : ", JSON.stringify(doc.data()));
                let record = doc.data();
                const {
                    dev_id: dev_id = "",
                    dt: date = "",
                    en_con: energyConsumption,
                    rs_at: autoModeRunTime,
                    rs_bp: byPassModeRunTime,
                    rs_ex: expectedRunTime,
                    rs_mn: manualModeRunTime,
                    bl: burnLoad,
                    bw: baseWatts,
                    ow: oldWatts,
                    en_con: actualConsumption,
                    // wd_id: wardId,
                    // zn_id: zoneId,
                } = record;

                let device = DeviceDataService.getInstance().getDeviceByDevId(dev_id);
                if (device != null) {
                    // date
                    let on_time = 0;
                    let powerPercentage = 0;
                    let correctionFactor = 0;
                    let baseLineKwh = 0;
                    let adjustedBaselinekWh = 0;
                    let expectedRunHrs = 0;
                    let enerygySaved = 0;
                    let enerygySavedPercentage = 0;
                    let location = "";
                    let dateStr = "";
                    let status = "NA";

                    if (date?.seconds) {
                        dateStr = format(new Date(date.seconds * 1000), "dd/MM/yyyy");
                    }

                    //On Time calculation
                    on_time = autoModeRunTime + manualModeRunTime;

                    //Power calculation
                    if (expectedRunTime > 0) {
                        powerPercentage = (on_time / expectedRunTime).toFixed(2);
                    }

                    //Correction Factor
                    if (baseWatts > 0) {
                        correctionFactor = (burnLoad / baseWatts).toFixed(2);
                    }

                    expectedRunHrs = expectedRunTime / 3600.0;
                    baseLineKwh = (oldWatts * expectedRunHrs) / 1000.0

                    //Adjusted Baseline kWh
                    adjustedBaselinekWh = (baseLineKwh * correctionFactor * powerPercentage).toFixed(2);

                    //Enerygy Saved
                    enerygySaved = Math.abs(actualConsumption - adjustedBaselinekWh).toFixed(2);

                    //Enerygy Saved Percentage
                    enerygySavedPercentage = Math.abs(enerygySaved / adjustedBaselinekWh).toFixed(2);

                    //Location
                    const {
                        zone: zoneStr = "",
                        ward: wardStr = "",
                        place = "",
                        street = "",
                    } = DeviceAddressService.getInstance().getAddress(device.zn_id, device.wd_id, device.pl_id, device.streetId);
                    location = `${place},${street}`;

                    //Status
                    if (((burnLoad * 100) / baseWatts) < 75) {
                        status = "HNB";
                    } else if (device.err_cnt === 0) {
                        status = "OK"
                    } else if (device?.errors?.findIndex(element => element === 5001) > 0) {
                        status = "NC";
                    } else {
                        status = "FAIL";
                    }

                    //Add to report list
                    reportList = [
                        ...reportList,
                        {
                            date: dateStr,
                            zn_id: device.zn_id,
                            wd_id: device.wd_id,
                            sc_no: device.sc_no,
                            sim_no: device.sim_no,
                            dev_id: dev_id,
                            location: location,
                            addr: device.addr,
                            ctr_ty: device.ctr_ty,
                            dev_md: device.dev_md,
                            on_time: on_time,
                            pp: powerPercentage,
                            bl: burnLoad,
                            bw: baseWatts,
                            cf: correctionFactor,
                            bkwh: baseLineKwh.toFixed(2),
                            abl: adjustedBaselinekWh,
                            en_com: actualConsumption,
                            es: enerygySaved,
                            esp: enerygySavedPercentage,
                            status: status,
                            zn: device.zn,
                            wd: device.wd,
                        },
                    ];
                }

            });
            resolve(reportList);
        }).catch((error) => {
            console.log(`====> Error fetch : ${error}`);
            reject(error);
        });
    });

}
export function GetLampErrorReport(startDate, endDate, zone = 0, ward = 0,) {
    console.log("===== ReportManager : GetDailyReport() ========");
    var reportList = [];
    return new Promise(function (resolve, reject) {
        GetLampReportQuery(startDate, endDate, zone, ward).then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                console.log("ReportManager : GetDailyReport() users docs : ", JSON.stringify(doc.data()));
                try {
                    let record = doc.data();
                    const {
                        dev_id: dev_id = "",
                        dt: date = "",
                        st: st = 0
                    } = record;
                    let lamp = LampDataService.getInstance().getDeviceByDevId(dev_id);
                    const {
                        slc_id: slc_uid = "",
                        pid: pid = "",
                        // wd: wd = "",
                        wt: wt = "",
                        wd: ward,
                        zn: zone,
                        ilm_id: ilm_id = "",
                        dev_st: dev_st,
                    } = lamp || {};
                    let device = DeviceDataService.getInstance().getDeviceByPID(slc_uid)
                    const {
                        uid: uid,
                    } = device || {};

                    let pole = null
                    let poleAddr = ""
                    if (pid != undefined && pid != null) {
                        pole = PoleDataService.getInstance().getPole(pid);
                    }
                    if (pole != null && pole.addr != undefined && pole.addr != null) {
                        poleAddr = pole.addr;
                    }
                    let degreeSymbol = "\u00B0";
                    let location = "";
                    let latitude = 0;
                    let longitude = 0;

                    if (pole != null && pole?.loc != undefined && pole?.loc != null) {
                        latitude = pole.loc?._lat || 0;
                        longitude = pole.loc?._long || 0;
                    } else if (device?.lloc != undefined) {
                        latitude = device.lloc?._lat || 0;
                        longitude = device.lloc?._long || 0;
                    } else if (device?.loc != undefined) {
                        latitude = device.loc?._lat || 0;
                        longitude = device.loc?._long || 0;
                    }


                    if ((latitude === undefined | "") || (longitude === undefined | "")) {
                        location = "N/A"
                    } else {
                        if (latitude > 0) {
                            location = `${latitude.toFixed(4)}${degreeSymbol}N`;
                        } else {
                            location = `${latitude.toFixed(4)}${degreeSymbol}S`;
                        }
                        if (longitude > 0) {
                            location = `[${location}, ${longitude.toFixed(4)}${degreeSymbol}E]`;
                        } else {
                            location = `[${location}, ${longitude.toFixed(4)}${degreeSymbol}W]`;
                        }
                    }
                    // debugger;  
                    if (lamp != null) {
                        reportList = [
                            ...reportList,
                            {
                                date: new Date(date.seconds * 1000),
                                lamp_uid: dev_id,
                                lim_uid: ilm_id,
                                wt: wt,
                                slc_uid: uid,
                                zn: zone,
                                wd: ward,
                                addr: poleAddr,
                                location: location,
                                dev_st: lampStatusCode[st]
                            },
                        ];
                    }
                } catch (e) {
                    console.error(`====> Report manager lamp failure parsing error : ${e}`);
                }

            });
            resolve(reportList);
        }).catch((error) => {
            console.log(`====> Error fetch : ${error}`);
            reject(error);
        });
    });

}